import type { ResearchView } from '@/utils/clubResearch';

export default function ResearchViewToggle({ value, onChange }: { value: ResearchView; onChange: (view: ResearchView) => void }) {
  return (
    <div className="mx-auto mb-3 grid min-h-11 w-full max-w-sm grid-cols-2 rounded-lg border border-gray-700 bg-primary-dark p-1" role="group" aria-label="Research view">
      {(['players', 'teams'] as const).map(view => (
        <button key={view} type="button" aria-pressed={value === view} onClick={() => onChange(view)}
          className={`min-h-9 rounded-md px-4 text-sm font-bold transition-colors duration-150 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-yellow ${value === view ? 'bg-accent-yellow text-primary' : 'text-gray-400 hover:text-white'}`}>
          {view === 'players' ? 'Players' : 'Teams'}
        </button>
      ))}
    </div>
  );
}
